export const fathomEvent = (site, event, route) => {
	if (window.fathom) {
		const qualifiedEvent = `${site}--${event}--${route}`
		window.fathom.trackEvent(qualifiedEvent)
	}
}

export const FATHOM_EVENTS = {
	timepageIos: 'timepage-appstore-ios',
	timepageMacos: 'timepage-appstore-macos',
	actionsIos: 'actions-appstore-ios',
	actionsIpados: 'actions-appstore-ipados',
	actionsMacos: 'actions-appstore--macos',
	actionsWeb: 'actions-web',
	flowIos: 'flow-appstore-ios',
	flowIpados: 'flow-appstore-ipados',
	flowWeb: 'flow-web',
	overlapIos: 'overlap-appstore-ios',
	overlapMacos: 'overlap-appstore-macos',
	bundle: 'bundle-appstore',
}
